'use client'

import * as React from 'react'
import { Progress } from 'radix-ui'

import { cn } from '@/utilities/ui'

function ProgressBar({ className, value, ...props }: React.ComponentProps<typeof Progress.Root>) {
  return (
    <Progress.Root
      data-slot="progress"
      className={cn(
        'relative flex h-1.5 w-full items-center overflow-x-hidden rounded-full bg-muted',
        className,
      )}
      {...props}
    >
      <Progress.Indicator
        data-slot="progress-indicator"
        className="size-full flex-1 bg-accent transition-all"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </Progress.Root>
  )
}

export { ProgressBar as Progress }
